export default [
    '#EE7163',
    '#F4AD5F',
    '#F9D76B',
    '#82D378',
    '#5A95F8',
    '#B67BDF',
    '#A5A5A8'
];

export function asHexColor(value: string): HexColor {
    if (!/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(value)) {
        throw new Error(`Invalid hex color: ${value}`);
    }
    return value as HexColor;
}
